import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { SnackerService } from '../../shared/snacker.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ThemeService } from '../../../services/theme.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule, NgxSpinnerModule, MatSnackBarModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Output() sideNavToggled = new EventEmitter<boolean>();
  menuStatus: boolean = false;
  userFullName;
  currentTheme = 'default';

  constructor(private router: Router, private spinner: NgxSpinnerService, private snacker: SnackerService,
    private cookieService: CookieService,
    private themeService: ThemeService
  ) { }

  ngOnInit(): void {
    this.userFullName = sessionStorage.personName;
    // Initialize default theme on app startup
    this.themeService.setTheme('default');
  }
  sideNavToggle() {
    this.menuStatus = !this.menuStatus;
    this.sideNavToggled.emit(this.menuStatus);
  }

  onProfileMenuClose() {
    this.isThemeMenuOpen = false;
  }

  profileView() {
    this.spinner.show();
    this.router.navigate(["homepage/profile"]);
    this.spinner.hide();
    this.isThemeMenuOpen = false;
  }

  get currentUserRoleId(): number {
    return Number(sessionStorage.getItem('roleId') || '0');
  }

  goToAllProfilePhotos() {
    this.router.navigate(['homepage/person-management'], { queryParams: { view: 'photos' } });
    this.isThemeMenuOpen = false;
  }

  isThemeMenuOpen: boolean = false;

  toggleThemeMenu() {
    this.isThemeMenuOpen = !this.isThemeMenuOpen;
  }

  setTheme(theme: string) {
    const normalized = (theme || 'default').trim().toLowerCase();

    this.currentTheme = normalized;
    this.themeService.setTheme(normalized);
    this.isThemeMenuOpen = false;
  }

  logOut() {
    this.cookieService.delete('projectName')
    this.spinner.show();
    localStorage.clear();
    sessionStorage.clear();
    this.snacker.success("logged out successfuly");
    this.router.navigate(['login']);
    this.isThemeMenuOpen = false;
    this.spinner.hide();

  }
}
